export default {
    async getToken(secretKey, apiKey) {
        if (!secretKey || !apiKey) return null;

        let response = await fetch(
            `${process.env.VUE_APP_TT_API_HOST}/ttid/${process.env.VUE_APP_TT_ENV}/token`,
            {
                method: 'POST',
                headers: {
                    'x-api-key': apiKey,
                },
                mode: 'cors',
                body: `grant_type=user_app&app_key=${secretKey}`,
            }
        );

        response = await response.json();
        return response.access_token;
    },

    async getPositions(token, apiKey, requestId) {
        if (!token || !apiKey) return [];
        let response = await fetch(
            `${process.env.VUE_APP_TT_API_HOST}/monitor/${process.env.VUE_APP_TT_ENV}/position?requestId=myApp-myCompany--${requestId}`,
            {
                method: 'GET',
                headers: {
                    'x-api-key': apiKey,
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        response = await response.json();
        if (response) return response;
    },
    async getData(token, apiKey, instrumentId) {
        if (!token || !apiKey || !instrumentId) return [];
        let response = await fetch(
            `${process.env.VUE_APP_TT_API_HOST}/pds/${process.env.VUE_APP_TT_ENV}/instrument/${instrumentId}`,
            {
                method: 'GET',
                headers: {
                    'x-api-key': apiKey,
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        response = await response.json();
        if (response) return response;
    },
};
